import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";

const SparkIcon = {
  name: 'SparkIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function (s) {
        return !isNaN(s) || (s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x');
      }
    },
    // Adding the 'gradient' prop for consistent styling
    gradient: {
      type: Array,
      default: () => ['#FB5607', '#FFC243'], // A warm gradient default (example)
      validator: function (arr) {
        // Ensures it's an array with exactly two string elements
        return arr.length === 2 && typeof arr[0] === 'string' && typeof arr[1] === 'string';
      }
    }
  },
  functional: true,
  render: function (h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' 
      ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em'
      : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    
    // Destructure the single 'gradient' prop into its start and end colors
    const [gradientStartColor, gradientEndColor] = ctx.props.gradient;

    // Generate unique IDs for the linear gradients to prevent conflicts
    const uniqueIdSuffix = Math.random().toString(36).substring(2, 9);
    const gradientId0 = `sparkGradient0_${uniqueIdSuffix}`;
    const gradientId1 = `sparkGradient1_${uniqueIdSuffix}`;
    
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "38",
        height: "38",
        viewBox: "-3 -1 45 40",
        fill: "none",
        "stroke-width": "0.75",
        "stroke-linecap": "round",
        "stroke-linejoin": "bevel"
      },
      "class": "feather feather-spark" 
    }, ctx.data]), [
      // Definitions for linear gradients (moved to the top within <svg>)
      h("defs", {}, [
        // Gradient for the main spark path
        h("linearGradient", {
          attrs: {
            id: gradientId0, // Using the unique ID
            x1: "37", // Right
            y1: "0",  // Top (adjust as needed for specific angle)
            x2: "0",  // Left
            y2: "37", // Bottom (adjust as needed for specific angle)
            gradientUnits: "userSpaceOnUse"
          }
        }, [
          h("stop", { attrs: { "stop-color": gradientStartColor } }),
          h("stop", { attrs: { offset: "1", "stop-color": gradientEndColor } })
        ]),
        // Gradient for the smaller spark detail
        h("linearGradient", {
          attrs: {
            id: gradientId1, // Using the unique ID
            x1: "37", // Right
            y1: "0",  // Top
            x2: "0",  // Left
            y2: "37", // Bottom
            gradientUnits: "userSpaceOnUse"
          }
        }, [
          h("stop", { attrs: { "stop-color": gradientStartColor } }),
          h("stop", { attrs: { offset: "1", "stop-color": gradientEndColor } })
        ])
      ]),
      h("path", {
        attrs: {
          d: "M37 18.9811C34.6822 19.681 30.7639 21.1943 26.9561 24.6181C21.6949 29.3661 19.7082 35.0031 19.0092 37.5C18.6229 35.4571 17.2616 29.839 12.35 25.0343C7.91671 20.7025 3.0419 19.4162 1 19C3.11548 18.4703 8.02709 16.9571 12.4788 12.4361C17.0041 7.82055 18.4941 2.67536 18.9908 0.5C19.6714 2.88344 21.2902 7.30982 25.1165 11.4903C29.5866 16.3707 34.627 18.2812 36.9816 19L37 18.9811Z",
          stroke: `url(#${gradientId0})` // Applies the main gradient
        }
      }),
      h("path", {
        attrs: {
          d: "M33.5264 3.90234C33.7547 4.3417 34.0627 4.82439 34.4746 5.30273L34.6582 5.50781L34.6621 5.5127C35.3392 6.22254 36.0609 6.68929 36.6719 7C36.2588 7.20559 35.8083 7.47985 35.3594 7.8418L35.1689 8.00098L35.166 8.00293C34.3977 8.67659 33.8911 9.41263 33.5566 10.0479C33.3167 9.51803 32.9566 8.91548 32.4141 8.34473L32.1729 8.10547C31.6151 7.57569 31.0325 7.21967 30.5137 6.97852C31.0483 6.71378 31.6503 6.32721 32.2207 5.75684C32.844 5.1335 33.2543 4.47363 33.5264 3.90234Z",
          fill: gradientStartColor, // Fill now uses the gradient's start color
          stroke: `url(#${gradientId1})` // Stroke uses the second gradient
        }
      })
    ]);
  }
};

export default SparkIcon;